'use client';
import React from 'react';
import get from 'lodash/get';
import { checkType } from '@/common/ultils';
import Image from 'next/image';

const OtherBanner = ({ footerBanners, deviceType }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
      {get(footerBanners, 'results', []).map((banner, idx) => {
        const fileUrl = checkType(deviceType === 'mobile' ? 'mobile' : 'tablet', banner, 0, 'fileUrl', 'sharpMedias');
        return (
          <a href={`${banner.linkTo}`} key={idx} className="bg-gray-100 w-full flex items-center justify-center overflow-hidden">
            {fileUrl ? (
              // <img src={fileUrl} alt={banner.name} className="w-full h-auto " loading="lazy" />
              <Image src={fileUrl} alt={banner.name} className="w-full h-auto position-initial" fill loading="lazy" />
            ) : (
              <span className="text-gray-600">{banner.name}</span>
            )}
          </a>
        );
      })}
    </div>
  );
};

export default OtherBanner;

